import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {WorkflowService} from '../../../service/workflow.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Workflow} from '../../../model/Workflow';
import {InformType} from '../../../../global/util/enum/InformType';
import {Constant} from '../../../../global/util/Constant';
import {AuthService} from '../../../service/auth/auth.service';
import {Enterprise} from '../../../model/Enterprise';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {Workflowtype} from '../../../model/Workflowtype';
import {Partner} from '../../../model/Partner';
import {WorkflowType} from '../../../../global/util/WorkflowType';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {Dialog} from '../../../../global/util/Dialog';
import {TranslateService} from '@ngx-translate/core';
import {MoreAboutWorkflow} from '../../../model/common/MoreAboutWorkflow';
import {WorkflowMoreCondition} from '../../../model/WorkflowMoreCondition';
import {EnterpriseDataService} from '../../../service/data/enterprise-data.service';

@Component({
  selector: 'app-add-edit-workflow',
  templateUrl: './add-edit-workflow.component.html',
  styleUrls: ['./add-edit-workflow.component.css']
})
export class AddEditWorkflowComponent implements OnInit {
  public loading: boolean;
  public workflowform: FormGroup;
  public workflow: Workflow;
  public partnerSelected: Partner;
  public enterprises: Enterprise[] = [];
  public partners: Partner[] = [];
  public workflowtypes: Workflowtype[] = [];
  public workflowIdSelected: number;
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public checkedDynamically: boolean;
  public checkedMinParticipants = false;
  public isPasswordCorrect = true;
  public checkedSignFreely: boolean;
  public checkedNotificationByDocument: boolean;
  public checkedCompletionAlertCharge: boolean;
  public checkedExtractCoordinates: boolean;
  public checkedCancellationAlertReviewer: boolean;
  public checkedDocumentSelection2Sign: boolean;
  public checkedReceiveDocumentFromFinishedWorkflow = false;
  public checkedSequentialNumber = false;
  public workflowSelected: any;
  public checkedUploadDocument2Workflow = false;
  public checkedCertifyDocument = false;
  public checkedGetExternalDocument = false;
  public workflows: Workflow[] = [];
  public workflows2Upload: Workflow[] = [];
  public title = 'TITLE.WORKFLOWS';
  private moreAboutWorkflow: MoreAboutWorkflow;
  public checkedMinSignerParticipants = false;
  public checkedMinReviewParticipants = false;
  public checkedAddManifest: boolean;
  public checkedAddTraceability: boolean;

  constructor(public activeModal: NgbActiveModal,
              private workflowService: WorkflowService,
              private formBuilder: FormBuilder,
              private authenticationService: AuthService,
              private enterpriseDataService: EnterpriseDataService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.createForm();
    this.loadInitialData();
    this.setDefaultData();
    if (this.isNewWorkflow) {
      this.workflow.batch = Constant.ONE2ONE;
      this.workflow.type = Constant.SIE_SIGN;
    }
  }

  private setDefaultData() {
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      if (this.isNewWorkflow) {
        this.partnerSelected = this.partners[Constant.ZERO_INDEX];
        this.enterprises = this.getEnterprises(this.partnerSelected.id);
      } else {
        const enterprise = this.getEnterprisesBy(this.workflow.enterpriseId);
        this.partnerSelected = this.partners.find(value => value.id === enterprise[Constant.ZERO_INDEX].partnerId);
        this.enterprises = this.getEnterprises(this.partnerSelected.id);
        this.workflowform.get('manageDocumentChecked').setValue(this.workflow._more.manageDocumentChecked);
        if (this.workflow._more.workflowMoreCondition) {
          const workflowMoreCondition = this.workflow._more.workflowMoreCondition;
          this.checkedMinSignerParticipants = workflowMoreCondition.checkedMinSignerToFinalize;
          this.checkedMinReviewParticipants = workflowMoreCondition.checkedMinReviewToFinalize;
          this.workflowform.get('minSignerToFinalize').setValue(workflowMoreCondition.minSignerToFinalize);
          this.workflowform.get('minReviewToFinalize').setValue(workflowMoreCondition.minReviewToFinalize);
          this.workflowform.get('checkedAddManifest').setValue(workflowMoreCondition.checkedAddManifest);
          this.workflowform.get('checkedAddTraceability').setValue(workflowMoreCondition.checkedAddTraceability);
          this.workflowform.get('checkedNotifyAttachToReviewers').setValue(workflowMoreCondition.checkedNotifyAttachToReviewers);
          this.workflowform.get('checkedPreventDuplicateSubject').setValue(workflowMoreCondition.checkedPreventDuplicateSubject);
        }
      }
    } else if (this.hasRole(this.ROLE_SUPERADMIN) || this.hasRole(this.ROLE_PARTNER)) {
      if (this.isNewWorkflow) {
        this.workflow.enterpriseId = this.enterprises[Constant.ZERO_INDEX].id;
        this.workflowIdSelected = Constant.ZERO_INDEX;
      } else {
        const existsEnterprise = this.enterprises.find(enterprise => enterprise.id === this.workflow.enterpriseId) !== undefined;
        if (existsEnterprise) {
          this.workflow.enterpriseId = this.enterprises.find(enterprise => enterprise.id === this.workflow.enterpriseId).id;
        }
        this.workflowform.get('manageDocumentChecked').setValue(this.workflow._more.manageDocumentChecked);
      }
    }
    this.checkedDynamically = this.workflow.dynamic === Constant.DYNAMICALLY;
    this.checkedSignFreely = this.workflow.freelySignature;
    this.checkedMinParticipants = this.workflow.minParticipantsToFinalize !== undefined;
    this.checkedNotificationByDocument = this.workflow.notificationByDocument;
    this.checkedCompletionAlertCharge = this.workflow.completionAlertCharge;
    this.checkedExtractCoordinates = this.workflow.extractCoordinates;
    this.checkedCancellationAlertReviewer = this.workflow.cancellationAlertReviewer;
    this.checkedDocumentSelection2Sign = this.workflow.documentSelection2Sign;
    if (this.workflow._more) {
      this.workflowform.get('manageDocumentChecked').setValue(this.workflow._more.manageDocumentChecked);
      if (this.workflow._more.workflowMoreCondition) {
        const workflowMoreCondition = this.workflow._more.workflowMoreCondition;
        this.checkedMinSignerParticipants = workflowMoreCondition.checkedMinSignerToFinalize;
        this.checkedMinReviewParticipants = workflowMoreCondition.checkedMinReviewToFinalize;
        this.checkedAddManifest = workflowMoreCondition.checkedAddManifest;
        this.checkedAddTraceability = workflowMoreCondition.checkedAddTraceability;
        this.checkedUploadDocument2Workflow = workflowMoreCondition.uploadDocument2Workflow;
        this.checkedGetExternalDocument = workflowMoreCondition.checkedGetExternalDocument;
        this.checkedCertifyDocument = workflowMoreCondition.checkedCertifyDocument;
        this.checkedReceiveDocumentFromFinishedWorkflow = workflowMoreCondition.receiveDocumentFromFinishedWorkflow;
        this.checkedSequentialNumber = workflowMoreCondition.sequentialNumber;
        if (this.isNewWorkflow) {
          this.workflowIdSelected = Constant.ZERO_INDEX;
        } else {
          this.workflowIdSelected = workflowMoreCondition.upload2WorkflowId;
        }
        this.workflowform.get('password2Upload').setValue(workflowMoreCondition.password2Upload);
        this.workflowform.get('passwordWorkflow').setValue(workflowMoreCondition.passwordWorkflow);
        this.workflowform.get('sequentialNumberWorkflow').setValue(workflowMoreCondition.sequentialNumberWorkflow);
        this.workflowform.get('minSignerToFinalize').setValue(workflowMoreCondition.minSignerToFinalize);
        this.workflowform.get('minReviewToFinalize').setValue(workflowMoreCondition.minReviewToFinalize);
        this.workflowform.get('checkedNotifyAttachToReviewers').setValue(workflowMoreCondition.checkedNotifyAttachToReviewers);
        this.workflowform.get('checkedPreventDuplicateSubject').setValue(workflowMoreCondition.checkedPreventDuplicateSubject);
      }
    }
  }

  private loadInitialData() {
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      this.partners = LocalStorage.getPartners();
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      this.enterprises = this.enterpriseDataService.getEnterprises().filter(enterprise => enterprise.id !== 0);
    }
    this.workflowtypes = LocalStorage.getWorkflowtypes();
    const url = Constant.ROOT_API_V1
      .concat('/workflows/')
      .concat('uploadDocument');
    this.workflowService.get(url).subscribe((value: any) => {
      this.workflows2Upload = value._embedded.workflows;
      const unique: Workflow[] = [{
        id: 0,
        description: 'SELECCIONE',
      }];
      this.workflows2Upload = unique.concat(this.workflows2Upload);
    }, error => {
      if (HttpStatusCode.METHOD_FAILURE === error.status) {
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.WORKFLOWS'), error.error.message);
        this.activeModal.close(InformType.Anything);
      }
      this.loading = false;
      this.activeModal.close(InformType.Danger);
    });
  }

  public reloadDocuments2() {
    /*    this.workflowIdSelected = this.workflowSelected.id;*/
  }

  /**
   * Realiza la validación de la contraseña del flujo.
   */
  public validate() {
    if (this.workflowform.invalid) {
      Object.values(this.workflowform.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }
    this.loading = true;
    const validateUrl = Constant.ROOT_API_V1
      .concat('/workflows/')
      .concat(String(this.workflowIdSelected))
      .concat('/password/')
      .concat(String(this.fieldValue(Field.password2Upload)));
    this.workflowService.get(validateUrl).subscribe((next: boolean) => {
      this.isPasswordCorrect = next;
      if (next) {
        Dialog.show(InformType.Warning, this.translate.instant('LABEL.WORKFLOW'), this.translate.instant('MESSAGE.CORRECT-VALIDATION'));
      } else {
        Dialog.show(InformType.Warning, this.translate.instant('LABEL.WORKFLOW'), this.translate.instant('MESSAGE.INCORRECT-VALIDATION'));
      }
      this.loading = false;
    }, error => {
      this.loading = false;
      this.processError(this.translate.instant('TITLE.WORKFLOW'), error);
    });
  }

  public save() {
    if (this.workflowform.invalid) {
      Object.values(this.workflowform.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }
    this.loading = true;
    this.setValuesBefore2Save();
    if (!this.isPasswordCorrect) {
      Dialog.show(InformType.Warning, this.translate.instant('LABEL.WORKFLOW'), this.translate.instant('MESSAGE.SAVE-WORKFLOW-WITH-VALIDATION'));
      this.loading = false;
      return;
    }
    if (this.isNewWorkflow) {
      this.register();
    } else {
      this.edit();
    }
  }

  private register() {
    this.workflow.completed = this.selectedAssignmentDynamically ? Constant.COMPLETED : Constant.INCOMPLETE;
    this.workflow.freelySignature = this.selectedFreelySignature;
    this.workflow.notificationByDocument = this.selectedNotificationByDocument;
    this.workflow.completionAlertCharge = this.selectedCompletionAlertCharge;
    this.workflow.extractCoordinates = this.selectedExtractCoordinates;
    this.workflow.cancellationAlertReviewer = this.selectedCancellationAlert4Reviewer;
    this.workflow.documentSelection2Sign = this.selectedDocumentSelection2Sign;
    this.workflowService.save(this.workflow).subscribe(workflow => {
      LocalStorage.updateEmbeddedValuesBy(workflow, 'workflows', Constant.ADD);
      this.loading = false;
      this.activeModal.close(InformType.Success);
    }, error => {
      if (HttpStatusCode.METHOD_FAILURE === error.status) {
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.WORKFLOWS'), error.error.message);
        this.activeModal.close(InformType.Anything);
      }
      this.loading = false;
      this.activeModal.close(InformType.Danger);
    });
  }

  private edit() {
    this.workflowService.edit(this.workflow).subscribe(workflow => {
      LocalStorage.updateEmbeddedValuesBy(workflow, 'workflows', Constant.EDIT);
      this.loading = false;
      this.activeModal.close(InformType.Success);
    }, error => {
      if (HttpStatusCode.METHOD_FAILURE === error.status) {
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.WORKFLOWS'), error.error.message);
        this.activeModal.close(InformType.Anything);
      }
      this.loading = false;
      this.activeModal.close(InformType.Danger);
    });
  }

  private setValuesBefore2Save() {
    const workflowMoreCondition = new WorkflowMoreCondition();
    // Aquí debería realizarse la extracción de datos del formulario y establecerlo a la entidad
    this.workflow.notificateAfterUpload = this.fieldValue(Field.notificateAfterUpload);
    this.workflow.send2MailAfterUpload = this.fieldValue(Field.send2MailAfterUpload);
    this.workflow.send2Visualization = this.fieldValue(Field.send2Visualization);
    this.workflow.notifyAfterUpload = this.fieldValue(Field.notifyAfterUpload);
    this.workflow.scheduledNotify = this.fieldValue(Field.scheduledNotify);
    this.workflow.xmlAsDatasource = this.fieldValue(Field.xmlAsDatasource);
    this.moreAboutWorkflow = new MoreAboutWorkflow();
    if (this.fieldValue(Field.manageDocumentChecked)) {
      this.moreAboutWorkflow.manageDocumentChecked = this.fieldValue(Field.manageDocumentChecked);
      this.workflow._more = this.moreAboutWorkflow;
    }
    workflowMoreCondition.uploadDocument2Workflow = this.checkedUploadDocument2Workflow;
    workflowMoreCondition.checkedGetExternalDocument = this.checkedGetExternalDocument;
    workflowMoreCondition.checkedCertifyDocument = this.checkedCertifyDocument;
    workflowMoreCondition.receiveDocumentFromFinishedWorkflow = this.checkedReceiveDocumentFromFinishedWorkflow;
    workflowMoreCondition.sequentialNumber = this.checkedSequentialNumber;
    if (this.checkedUploadDocument2Workflow) {
      workflowMoreCondition.password2Upload = this.fieldValue(Field.password2Upload);
      workflowMoreCondition.upload2WorkflowId = this.workflowIdSelected;
    }
    if (this.checkedReceiveDocumentFromFinishedWorkflow) {
      workflowMoreCondition.passwordWorkflow = this.fieldValue(Field.passwordWorkflow);
    }
    if (this.checkedSequentialNumber) {
      workflowMoreCondition.sequentialNumberWorkflow = this.fieldValue(Field.sequentialNumberWorkflow);
    }
    workflowMoreCondition.checkedMinSignerToFinalize = this.checkedMinSignerParticipants;
    workflowMoreCondition.minSignerToFinalize = this.fieldValue(Field.minSignerToFinalize);
    workflowMoreCondition.checkedMinReviewToFinalize = this.checkedMinReviewParticipants;
    workflowMoreCondition.checkedAddManifest = this.checkedAddManifest;
    workflowMoreCondition.checkedAddTraceability = this.checkedAddTraceability;
    workflowMoreCondition.minReviewToFinalize = this.fieldValue(Field.minReviewToFinalize);
    workflowMoreCondition.checkedNotifyAttachToReviewers = this.fieldValue(Field.checkedNotifyAttachToReviewers);
    workflowMoreCondition.checkedPreventDuplicateSubject = this.fieldValue(Field.checkedPreventDuplicateSubject);
    this.moreAboutWorkflow.workflowMoreCondition = workflowMoreCondition;
    this.workflow._more = this.moreAboutWorkflow;
    if (!this.hasRole(this.ROLE_SUPERADMIN) && !this.hasRole(this.ROLE_PARTNER)) {
      this.workflow.enterpriseId = LocalStorage.getEnterpriseIdView();
    }
    if (this.workflow.deliver === undefined) {
      this.workflow.deliver = 0;
    }
    if (this.workflow.dynamic === undefined) {
      this.workflow.dynamic = 0;
    }
  }

  public cancel() {
    this.activeModal.close(AddEditWorkflowComponent);
  }

  get isNewWorkflow(): boolean {
    return this.workflow.id === undefined;
  }

  public isInvalidControl(ctrlName: string) {
    return this.workflowform.get(ctrlName).invalid && this.workflowform.get(ctrlName).touched;
  }

  get disableOnWorkflowIncorrect(): boolean {
    return this.workflowIdSelected === Constant.ZERO_INDEX;
  }

  private createForm() {
    this.workflowform = this.formBuilder.group(
      {
        partner: [''],
        enterprise: [''],
        workflowtype: [''],
        dynamic: [''],
        freelySignature: [''],
        description: ['', Validators.required],
        notificationByDocument: [''],
        completionAlertCharge: [''],
        workflows: [''],
        password2Upload: [''],
        passwordWorkflow: [''],
        sequentialNumberWorkflow: [''],
        uploadDocument2Workflow: [''],
        checkedCertifyDocument: [''],
        checkedExternalDocument: [''],
        receiveDocumentFromFinishedWorkflow: [''],
        sequentialNumber: [''],
        extractCoordinates: [''],
        cancellationAlertReviewer: [''],
        documentSelection2Sign: [''],
        maxParticipants: ['', Validators.compose([Validators.required, Validators.pattern('^[1-9][0-9]*$')])],
        minParticipants: [''],
        minParticipantsToFinalize: [''],
        groupRadio: ['', Validators.required],
        deliver: [''],
        code: [''],
        state: [''],
        minSignerToFinalize: [''],
        minReviewToFinalize: [''],
        notificateAfterUpload: [this.initialWorkflowValue(Field.notificateAfterUpload)],
        send2MailAfterUpload: [this.initialWorkflowValue(Field.send2MailAfterUpload)],
        send2Visualization: [this.initialWorkflowValue(Field.send2Visualization)],
        notifyAfterUpload: [this.initialWorkflowValue(Field.notifyAfterUpload)],
        scheduledNotify: [this.initialWorkflowValue(Field.scheduledNotify)],
        xmlAsDatasource: [this.initialWorkflowValue(Field.xmlAsDatasource)],
        manageDocumentChecked: [this.initialWorkflowValue(Field.manageDocumentChecked)],
        minSignerToFinalizeChecked: [this.initialWorkflowValue(Field.minSignerToFinalizeChecked)],
        minReviewToFinalizeChecked: [this.initialWorkflowValue(Field.minReviewToFinalizeChecked)],
        checkedAddTraceability: [this.initialWorkflowValue(Field.checkedAddTraceability)],
        checkedAddManifest: [this.initialWorkflowValue(Field.checkedAddManifest)],
        checkedPreventDuplicateSubject: [this.initialWorkflowValue(Field.checkedPreventDuplicateSubject)],
        checkedNotifyAttachToReviewers: [this.initialWorkflowValue(Field.checkedNotifyAttachToReviewers)]
      });
  }

  /**
   * Obtiene el valor inicial booleano del flujo de trabajo
   * @param field
   * @private
   */
  private initialWorkflowValue(field: string) {
    return this.workflow[field] ? this.workflow[field] : false;
  }

  public onDeliverChange(checked) {
    this.workflow.deliver = checked ? Constant.DELIVER : Constant.NOT_DELIVER;
  }

  public onAssignmentTypeChange() {
    this.workflow.dynamic = this.checkedDynamically ? Constant.DYNAMICALLY : Constant.STATICALLY;
    const control = this.workflowform.get('maxParticipants');
    if (this.workflow.dynamic === Constant.DYNAMICALLY) {
      this.workflow.maxParticipants = null;
      this.workflow.batch = 0;
      control.clearValidators();
      control.updateValueAndValidity();
    } else {
      control.setValidators(Validators.compose([Validators.required, Validators.pattern('^[1-9][0-9]*$')]));
      control.updateValueAndValidity();
    }
  }

  public onAssignmentSignFreely(checked) {
    this.workflow.freelySignature = checked;
    if (!this.workflow.freelySignature) {
      this.checkedMinSignerParticipants = false;
      this.checkedMinReviewParticipants = false;
    }
  }

  public onMinParticipantsToFinalize(event) {
    if (event) {
      this.checkedMinParticipants = true;
      if (this.workflow.minParticipantsToFinalize === null) {
        this.workflow.minParticipantsToFinalize = 1;
      }
      this.workflowform.get('minParticipantsToFinalize').setValidators(Validators.compose([Validators.required, Validators.pattern('^[1-9][0-9]*$')]));
      this.workflowform.get('minParticipantsToFinalize').updateValueAndValidity();
    } else {
      this.workflowform.get('minParticipantsToFinalize').clearValidators();
      this.workflowform.get('minParticipantsToFinalize').updateValueAndValidity();
      this.checkedMinParticipants = false;
      this.workflow.minParticipantsToFinalize = null;
    }
  }

  public onMinSignerParticipantsToFinalize(event) {
    if (event) {
      this.checkedMinSignerParticipants = true;
      if (this.workflowform.get('minSignerToFinalize').value === null) {
        this.workflowform.get('minSignerToFinalize').setValue(1);
      }
      this.workflowform.get('minSignerToFinalize').setValidators(Validators.compose([Validators.required, Validators.pattern('^[1-9][0-9]*$')]));
      this.workflowform.get('minSignerToFinalize').updateValueAndValidity();
    } else {
      this.workflowform.get('minSignerToFinalize').clearValidators();
      this.workflowform.get('minSignerToFinalize').updateValueAndValidity();
      this.checkedMinSignerParticipants = false;
      this.workflowform.get('minSignerToFinalize').setValue(null);
    }
  }

  public onMinReviewParticipantsToFinalize(event) {
    if (event) {
      this.checkedMinReviewParticipants = true;
      if (this.workflowform.get('minReviewToFinalize').value === null) {
        this.workflowform.get('minReviewToFinalize').setValue(1);
      }
      this.workflowform.get('minReviewToFinalize').setValidators(Validators.compose([Validators.required, Validators.pattern('^[1-9][0-9]*$')]));
      this.workflowform.get('minReviewToFinalize').updateValueAndValidity();
    } else {
      this.workflowform.get('minReviewToFinalize').clearValidators();
      this.workflowform.get('minReviewToFinalize').updateValueAndValidity();
      this.checkedMinReviewParticipants = false;
      // TODO: Obtener el valor de minimo de revisores de workflowform y setealo en worflowMoreCondition
      // this.workflow._more.workflowMoreCondition.minReviewParticipantsToFinalize = null;
      this.workflowform.get('minReviewToFinalize').setValue(null);
    }
  }

  onNotifyAttachToReviewersAndAssist(event: any) {
    if (event) {
      this.workflowform.get('checkedNotifyAttachToReviewers').setValue(event);
    } else {
      this.workflowform.get('checkedNotifyAttachToReviewers').setValue(false);
    }
    this.workflowform.get('checkedNotifyAttachToReviewers').updateValueAndValidity();
  }

  get selectedMinParticipantsToFinalize() {
    return !this.checkedMinParticipants === true;
  }

  get selectedMinSignerParticipantsToFinalize() {
    return !this.checkedMinSignerParticipants === true;
  }

  get selectedMinReviewParticipantsToFinalize() {
    return !this.checkedMinReviewParticipants === true;
  }

  get selectedAssignmentDynamically() {
    return this.workflow.dynamic === Constant.DYNAMICALLY;
  }

  get selectedFreelySignature(): boolean {
    const freelySignature = this.workflow.freelySignature;
    if (freelySignature) {
      return freelySignature;
    }
    return false;
  }

  public hasRole(roleDescription: string) {
    return this.authenticationService.hasRole(roleDescription);
  }

  get hasDeliverOption(): boolean {
    return LocalStorage.hasDeliverOption();
  }

  public reloadEnterprises() {
    this.enterprises = this.getEnterprises(this.partnerSelected.id);
    if (this.enterprises.length > 0) {
      if (this.isNewWorkflow) {
        this.workflow.enterpriseId = this.enterprises[Constant.ZERO_INDEX].id;
      } else {
        const existsEnterprise = this.enterprises.find(enterprise => enterprise.id === this.workflow.enterpriseId) !== undefined;
        if (existsEnterprise) {
          this.workflow.enterpriseId = this.enterprises.find(enterprise => enterprise.id === this.workflow.enterpriseId).id;
        } else {
          this.workflow.enterpriseId = this.enterprises[Constant.ZERO_INDEX].id;
        }
      }
    }
  }

  private getEnterprises(partnerId: number): Enterprise[] {
    const enterprises1 = this.enterpriseDataService.getEnterprises();
    return enterprises1.filter(value => partnerId === value.partnerId && Constant.NOT_EXCLUDED === value.excluded);
  }

  private getEnterprisesBy(enterpriseId: number): Enterprise[] {
    const enterprises1 = this.enterpriseDataService.getEnterprises();
    return enterprises1.filter(value => enterpriseId === value.id && Constant.NOT_EXCLUDED === value.excluded);
  }

  public reloadWorkflowOptions() {
    if (this.isNewWorkflow) {
      this.workflow.maxParticipants = !this.SNWithTemplateWorkflowType ? null : 1;
    }
    switch (this.workflow.type) {
      case WorkflowType.SIGNATURE:
        this.workflowform.get('maxParticipants').setValidators(Validators.compose([Validators.required, Validators.pattern('^[1-9][0-9]*$')]));
        this.workflowform.get('maxParticipants').updateValueAndValidity();
        if (this.isNewWorkflow) {
          this.workflow.maxParticipants = this.workflow.batch === Constant.BATCH ? 1 : null;
          this.workflowform.get('manageDocumentChecked').setValue(this.workflow.batch === Constant.BATCH ? false : null);
        }
        this.workflowform.get('send2Visualization').setValue(false);
        break;
      case WorkflowType.SIGNATURE_AND_NOTIFICATION:
        this.checkedDynamically = false;
        this.workflowform.get('maxParticipants').setValidators(Validators.compose([Validators.required, Validators.pattern('^[1-9][0-9]*$')]));
        this.workflowform.get('maxParticipants').updateValueAndValidity();
        if (this.isNewWorkflow) {
          this.workflow.maxParticipants = this.workflow.batch === Constant.BATCH ? 1 : null;
        }
        this.workflowform.get('manageDocumentChecked').setValue(false);
        this.workflowform.get('send2Visualization').setValue(false);
        break;
      case WorkflowType.SIGNATURE_AND_NOTIFICATION_WITH_TEMPLATE:
        this.workflowform.get('maxParticipants').clearValidators();
        this.workflowform.get('maxParticipants').updateValueAndValidity();
        this.workflowform.get('minParticipantsToFinalize').clearValidators();
        this.workflowform.get('minParticipantsToFinalize').updateValueAndValidity();
        this.workflow.batch = 0;
        this.workflow.maxParticipants = !this.SNWithTemplateWorkflowType ? this.workflow.maxParticipants : 1;
        this.workflow.minParticipantsToFinalize = null;
        this.checkedDynamically = false;
        this.checkedMinParticipants = false;
        this.checkedSignFreely = false;
        this.workflowform.get('manageDocumentChecked').setValue(false);
        this.workflowform.get('send2Visualization').setValue(false);
        break;
      case WorkflowType.UPLOAD_TO_IOFESIGN:
        this.workflowform.get('maxParticipants').setValidators(Validators.compose([Validators.required, Validators.pattern('^[1-9][0-9]*$')]));
        this.workflowform.get('minParticipantsToFinalize').clearValidators();
        this.workflowform.get('minParticipantsToFinalize').updateValueAndValidity();
        this.workflow.batch = 0;
        this.workflow.maxParticipants = !this.SNWithTemplateWorkflowType ? this.workflow.maxParticipants : 1;
        this.workflow.minParticipantsToFinalize = null;
        this.checkedDynamically = false;
        this.checkedMinParticipants = false;
        this.checkedSignFreely = false;
        this.workflowform.get('manageDocumentChecked').setValue(false);
        this.workflowform.get('send2Visualization').setValue(false);
        break;
      case WorkflowType.NOTCER:
        this.workflowform.get('maxParticipants').clearValidators();
        this.workflowform.get('maxParticipants').updateValueAndValidity();
        this.workflow.batch = 0;
        this.workflow.maxParticipants = !this.SNWithTemplateWorkflowType ? this.workflow.maxParticipants : 1;
        this.workflow.minParticipantsToFinalize = null;
        this.checkedDynamically = false;
        this.checkedMinParticipants = false;
        this.workflow.maxParticipants = 2;
        this.workflowform.get('send2Visualization').setValue(true);
        this.checkedSignFreely = false;
        this.workflowform.get('manageDocumentChecked').setValue(false);
        break;
    }
    this.workflowform.get('extractCoordinates').setValue(false);
    this.workflowform.get('cancellationAlertReviewer').setValue(false);
    this.workflowform.get('documentSelection2Sign').setValue(false);
    this.workflowform.get('notificateAfterUpload').setValue(false);
    this.workflowform.get('send2MailAfterUpload').setValue(false);
    this.workflowform.get('notifyAfterUpload').setValue(false);
    this.workflowform.get('xmlAsDatasource').setValue(false);
    this.workflowform.get('manageDocumentChecked').setValue(false);
  }

  get onlySignatureOptionSelected() {
    return WorkflowType.SIGNATURE === this.workflow.type && !this.workflow.freelySignature;
  }

  // TODO here!! refactorizar la verificación
  get disableToOptionSelected() {
    return this.workflow.dynamic === Constant.DYNAMICALLY ||
      this.SNWithTemplateWorkflowType || this.isNotcerWorkflowType ||
      (this.isUploadWorkflowType && (this.workflow.notificateAfterUpload || this.workflow.send2MailAfterUpload));
  }

  get isUploadWorkflowType(): boolean {
    return WorkflowType.UPLOAD_TO_IOFESIGN === this.workflow.type;
  }

  get isNotcerWorkflowType(): boolean {
    return WorkflowType.NOTCER === this.workflow.type;
  }

  get isSignatureWorkflowType(): boolean {
    return WorkflowType.SIGNATURE === this.workflow.type;
  }

  get isUploadDocumentToWorkflow(): boolean {
    return this.checkedUploadDocument2Workflow;
  }

  get isReceiveDocumentFromFinishedWorkflow(): boolean {
    return this.checkedReceiveDocumentFromFinishedWorkflow;
  }

  get isSequentialNumberWorkflow(): boolean {
    return this.checkedSequentialNumber;
  }

  /**
   * Verifica si el flujo es de tipo 'SIGNATURE_AND_NOTIFICATION_WITH_TEMPLATE'
   * @constructor
   */
  get SNWithTemplateWorkflowType(): boolean {
    return WorkflowType.SIGNATURE_AND_NOTIFICATION_WITH_TEMPLATE === this.workflow.type;
  }

  public setUpMaxParticipants() {
    switch (this.workflow.batch) {
      case Constant.ONE2ONE:
        if (this.isNewWorkflow) {
          this.workflow.maxParticipants = !this.SNWithTemplateWorkflowType ? null : 1;
        }
        break;
      case Constant.BATCH:
        if (this.isNewWorkflow) {
          this.workflow.maxParticipants = 1;
        }
        const control = this.workflowform.get('maxParticipants');
        control.markAsUntouched();
        this.checkedUploadDocument2Workflow = false;
        this.checkedGetExternalDocument = false;
        this.checkedCertifyDocument = false;
        this.checkedReceiveDocumentFromFinishedWorkflow = false;
        break;
    }
  }

  public addCompletionAlertCharge(checked) {
    this.workflow.completionAlertCharge = checked;
  }

  public addNotificationByDocument(checked) {
    this.workflow.notificationByDocument = checked;
  }

  public addExtractCoordinates(checked) {
    this.workflow.extractCoordinates = checked;
  }

  public addCancellationAlertReviewers(checked) {
    this.workflow.cancellationAlertReviewer = checked;
  }

  public addDocumentSelection2Sign(checked) {
    this.workflow.documentSelection2Sign = checked;
  }

  /**
   * Selecciona la opción de enviar documento a un flujo al finalizar.
   * @param checked
   */
  public addUploadDocument2Workflow(checked) {
    if (checked) {
      this.workflowform.get('password2Upload').setValidators(Validators.required);
      this.workflowform.get('password2Upload').updateValueAndValidity();
      if (this.workflow._more !== undefined) {
        this.isPasswordCorrect = this.workflow._more.workflowMoreCondition.upload2WorkflowId !== undefined;
      } else {
        this.isPasswordCorrect = false;
      }
    } else {
      this.workflowform.get('password2Upload').clearValidators();
      this.workflowform.get('password2Upload').updateValueAndValidity();
      this.isPasswordCorrect = true;
    }
    if (this.isNewWorkflow || this.workflow._more.workflowMoreCondition.upload2WorkflowId === undefined) {
      this.workflowIdSelected = Constant.ZERO_INDEX;
    }
  }

  /**
   * Selecciona la opción de recibir documentos de otro flujo al finalizar
   * @param checked
   */
  public addReceiveDocumentFromFinishedWorkflow(checked) {
    if (checked) {
      this.workflowform.get('passwordWorkflow').setValidators(Validators.required);
      this.workflowform.get('passwordWorkflow').updateValueAndValidity();
    } else {
      this.workflowform.get('passwordWorkflow').clearValidators();
      this.workflowform.get('passwordWorkflow').updateValueAndValidity();
    }
  }

  public addSequentialNumberWorkflow(checked) {
    if (checked) {
      this.workflowform.get('sequentialNumberWorkflow').setValidators(Validators.required);
      this.workflowform.get('sequentialNumberWorkflow').updateValueAndValidity();
    } else {
      this.workflowform.get('sequentialNumberWorkflow').clearValidators();
      this.workflowform.get('sequentialNumberWorkflow').updateValueAndValidity();
    }
  }

  isCheckedAddTraceability(checked: any) {
    this.checkedAddTraceability = checked;
  }

  isCheckedAddMenifest(checked: any) {
    this.checkedAddManifest = checked;
  }

  get selectedNotificationByDocument(): boolean {
    return this.workflow.notificationByDocument ? this.workflow.notificationByDocument : false;
  }

  get selectedCompletionAlertCharge(): boolean {
    return this.workflow.completionAlertCharge ? this.workflow.completionAlertCharge : false;
  }

  get selectedExtractCoordinates(): boolean {
    return this.workflow.extractCoordinates ? this.workflow.extractCoordinates : false;
  }

  get selectedCancellationAlert4Reviewer(): boolean {
    return this.workflow.cancellationAlertReviewer ? this.workflow.cancellationAlertReviewer : false;
  }

  get selectedDocumentSelection2Sign(): boolean {
    return this.workflow.documentSelection2Sign ? this.workflow.documentSelection2Sign : false;
  }

  public hasAuthority(code: string): boolean {
    return this.authenticationService.hasAuthority(code);
  }

  private fieldValue(field: string) {
    return this.workflowform.get(field).value;
  }

  isChecked(control: string) {
    return this.workflowform.get(control).value;
  }

  /**
   * Este metodo realiza el seteo de estado del Gestion de documento
   * Marcado =  true
   * Desmarcado = false
   */
  onManageDocument(checked: any) {
    const more = new MoreAboutWorkflow();
    if (checked) {
      more.manageDocumentChecked = true;
      this.workflow._more = more;
    } else {
      more.manageDocumentChecked = false;
      this.workflow._more = more;
    }
  }

  get isUploadInBatch() {
    return this.workflow.batch === Constant.BATCH;
  }

  getIconOnOrOf(active: number) {
    return Number(active) === 1 ? 'fas fa-toggle-on' : 'fas fa-toggle-off';
  }

  getBgColor(active: number) {
    return Number(active) === 1 ? 'input-group-text' : 'input-group-text-danger';
  }

  private processError(title: string, error: any) {
    const status = error.status;
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.SESSION-EXPIRED'), this.translate.instant('MESSAGE.SESSION-EXPIRED'));
      } else {
        Dialog.show(InformType.Danger, title);
      }
    } else {
      Dialog.show(InformType.Danger, title, error.error.message);
    }
  }
}

class Field {
  /**
   * Activa para el tipo de flujo 'Carga al IOFESign', la notificación del documento al domicilio asociado en el asunto
   */
  public static readonly notificateAfterUpload = 'notificateAfterUpload';
  /**
   * Activa para el tipo de flujo 'Carga al IOFESign', el envío del documento al correo electrónico asociado en el asunto
   */
  public static readonly send2MailAfterUpload = 'send2MailAfterUpload';
  /**
   * Activa para el tipo de flujo 'Carga al IOFESign', el envío del documento a la 'bandeja' del invitado para visualización
   */
  public static readonly send2Visualization = 'send2Visualization';
  /**
   * Activa para el tipo de flujo 'NOTCER', el envío del documento a la 'bandeja' del invitado para visualización
   */
  public static readonly notifyAfterUpload = 'notifyAfterUpload';
  /**
   * Activa para el tipo de flujo 'NOTCER', el envío del documento a la 'bandeja' del invitado para visualización
   */
  public static readonly scheduledNotify = 'scheduledNotify';
  /**
   * Activa el uso de fuente de datos un archivo <b>XML</b> que será emparejado con su respectiva plantilla con la
   * finalidad generar los archivos PDF
   */
  public static readonly xmlAsDatasource = 'xmlAsDatasource';

  /**
   * Activa el uso Gestionar documento lo cual permite al usuario indicar el tiempo de la vigencia o
   * renovación del documento
   */
  public static readonly manageDocumentChecked = 'manageDocumentChecked';
  /**
   * Activa el minino de firmantes para finalizar el flujo.
   */
  public static readonly minSignerToFinalizeChecked = 'minSignerToFinalizeChecked';
  /**
   * Activa el minino de revisores para finalizar el flujo.
   */
  public static readonly minReviewToFinalizeChecked = 'minReviewToFinalizeChecked';
  /**
   * Valor de minino de revisores para finalizar el flujo.
   */
  public static readonly minReviewToFinalize = 'minReviewToFinalize';
  /**
   * Valor de minino de firmantes para finalizar el flujo.
   */
  public static readonly minSignerToFinalize = 'minSignerToFinalize';
  /**
   * Condicional al finalizar el flujo se envia los documentos firmados al asistente y a los revisores.
   */
  public static readonly checkedNotifyAttachToReviewers = 'checkedNotifyAttachToReviewers';
  /**
   * Contraseña del flujo donde se enviaran los documentos.
   */
  public static readonly password2Upload = 'password2Upload';
  /**
   * Contraseña del flujo
   */
  public static readonly passwordWorkflow = 'passwordWorkflow';

  public static readonly sequentialNumberWorkflow = 'sequentialNumberWorkflow';
  /**
   * Se checkea esta opcion para agregar un manifiesto al documento cuando finalize con la firma gráfica
   */
  public static readonly checkedAddManifest = 'checkedAddManifest';
  /**
   * Se checkea esta opcion para agregar la trazabilidad al documento cuando finalize con la firma gráfica
   */
  public static readonly checkedAddTraceability = 'checkedAddTraceability';
  /**
   * Se checkea esta opcion para EVITAR duplicidad de asuntos del documento.
   */
  public static readonly checkedPreventDuplicateSubject = 'checkedPreventDuplicateSubject';
}
